export type ReportTypeOption = {
  readonly value: string
  readonly label: string
}

export function buildReportTypeOptions(translate: (item: string) => string): readonly ReportTypeOption[] {
  return [
    { value: '/report/occurrence-consultation', label: translate('Occurrence Consultation') },
    { value: '/report/dispatch-timeline', label: translate('Occurrence by chronology') },
    { value: '/report/occurrence-detail-by-type', label: translate('Occurrences by Type') },
    { value: '/report/dispatches-by-device', label: translate('Occurrences by device') },
    { value: '/report/occurrences', label: translate('Occurrences by dispatch group and type') },
    { value: '/report/occurrences-handled-by-group', label: translate('Occurrences Handled by Dispatch Group') },
    { value: '/report/dispatches-status-by-date', label: translate('Dispatches status by date') },
    { value: '/report/search-comments', label: translate('Search multiple coments') },
    { value: '/report/dispatch-by-closed-status', label: translate('Total occurrences by closing status') },
    { value: '/report/dispatches-by-commander', label: translate('Occurrences by commander') },
    { value: '/report/dispatches-statistics-by-commander', label: translate('Occurrences statistics by commander') },
    { value: '/report/devices', label: translate('List of Devices') },
    { value: '/report/connection-logs', label: translate('Connections Logs') },
    { value: '/report/devices-by-status', label: translate('List of devices by status on a date') },
    { value: '/report/device-services', label: translate('Device Services') },
    { value: '/report/devices-vs-dispatches', label: translate('Device status x Pending occurrences') },
    { value: '/report/connected-devices', label: translate('Total connected devices') },
    { value: '/report/device-timeline', label: translate('Device timeline') },
    { value: '/report/out-of-service-productivity', label: translate('Device productivity: Out of service status') },
    { value: '/report/on-mission-productivity', label: translate('Device productivity: On mission status') },
    { value: '/report/entry-by-status', label: translate('Entry log by status and user') },
    { value: '/report/total-entry-by-user', label: translate('Total entries by user') },
    { value: '/report/total-prank-calls', label: translate('Total prank calls registered') },
    { value: '/report/total-entry-by-accuracy', label: translate('Total entries by location accuracy and user') },
    { value: '/report/interest-point', label: translate('Interest points registered') },
    { value: '/report/total-qualifiers-searches-by-user', label: translate('Total qualifiers searches per user') },
    { value: '/report/qualifiers-records-by-options', label: translate('Registration of qualifiers') },
    { value: '/report/all-users', label: translate('List of Users') },
  ]
}

export function buildReportRouteMap(translate: (item: string) => string): Record<string, string> {
  const options = buildReportTypeOptions(translate)
  return options.reduce<Record<string, string>>(
    (acc, opt) => ({ ...acc, [opt.value]: opt.label }),
    {} as Record<string, string>
  )
}

export function findReportLabelByUrl(route: string, translate: (item: string) => string): string | undefined {
  const options = buildReportTypeOptions(translate)
  const found = options.find((opt) => opt.value === route)
  return found?.label
}